<template lang="html">
    <div class="col-md-12 grid-margin">
        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-4">
                    <h2 class="card-title mb-0">Total Income of the Day</h2>
                </div>
                <div class="chart-container">
                    <ve-histogram :data="chartData"></ve-histogram>
                </div>
            </div>
        </div>
    </div> 
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'totalscomparecard',
    
    data () {
        this.chartSettings = {
            dimension: ['total'],
            metrics: ['restaurant'],
            label: {
                normal : { show: true, position: 'top'}
            }
        }
        return {
            chartData: {
                columns: ['restaurant', 'total'],
                rows: [
                    
                ] 
            }
        } 
    },
    
    async created () {
        await this.$store.dispatch('orderscontrol/getCurrentOrdersByRestaurantOwnerAction');
        this.chartData.rows = this.$store.getters['orderscontrol/charts'];
    }
}
</script>
